var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyLinkIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 7.93213H14C13.45 7.93213 13 8.38213 13 8.93213C13 9.48213 13.45 9.93213 14 9.93213H17C18.65 9.93213 20 11.2821 20 12.9321C20 14.5821 18.65 15.9321 17 15.9321H14C13.45 15.9321 13 16.3821 13 16.9321C13 17.4821 13.45 17.9321 14 17.9321H17C19.76 17.9321 22 15.6921 22 12.9321C22 10.1721 19.76 7.93213 17 7.93213ZM8 12.9321C8 13.4821 8.45 13.9321 9 13.9321H15C15.55 13.9321 16 13.4821 16 12.9321C16 12.3821 15.55 11.9321 15 11.9321H9C8.45 11.9321 8 12.3821 8 12.9321ZM10 15.9321H7C5.35 15.9321 4 14.5821 4 12.9321C4 11.2821 5.35 9.93213 7 9.93213H10C10.55 9.93213 11 9.48213 11 8.93213C11 8.38213 10.55 7.93213 10 7.93213H7C4.24 7.93213 2 10.1721 2 12.9321C2 15.6921 4.24 17.9321 7 17.9321H10C10.55 17.9321 11 17.4821 11 16.9321C11 16.3821 10.55 15.9321 10 15.9321Z",
    fill: "#1FA37C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyLinkIcon);
export default __webpack_public_path__ + "static/media/copyLinkIcon.59e483f622cbece7a34f839b4854a52b.svg";
export { ForwardRef as ReactComponent };